import React, { useEffect, useState } from "react";
import axios from "axios";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import { Link } from "react-router-dom";

type Editorial = {
  id: number;
  judul: string;
  gambar: string;
  created_at: string;
};

const RekomendasiSlider: React.FC = () => {
  const [news, setNews] = useState<Editorial[]>([]);
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get(`${API}/api/editorial`);
        setNews(res.data.data || []);
      } catch (err) {
        console.error("Gagal mengambil data editorial", err);
      }
    };

    fetchNews();
  }, [API]);

  if (!news.length) return null;

  return (
    <section className="mt-10 mb-14 w-full">
      {/* TITLE */}
      <div className="flex items-center mb-6">
        <div className="bg-primary text-white px-4 py-2 font-semibold text-sm md:text-base rounded">Rekomendasi Untuk Anda</div>
        <div className="flex-1 border-b-2 border-primary ml-3"></div>
      </div>

      {/* SLIDER */}
      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        loop
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          480: {
            slidesPerView: 1.5,
          },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2.2,
          },
          1024: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 3.5,
          },
        }}>
        {news.map((item) => (
          <SwiperSlide key={item.id}>
            <article className="group cursor-pointer">
              {/* IMAGE */}
              <div className="overflow-hidden rounded-xl">
                <Link to={`berita/${item?.id}`}>
                  <img src={item.gambar} alt={item.judul} className="w-full h-[180px] sm:h-[200px] lg:h-[220px] object-cover transition duration-500 group-hover:scale-105" />
                </Link>
              </div>

              {/* TEXT */}
              <div className="mt-3 space-y-1">
                <Link to={`berita/${item?.id}`}>
                  <h3 className="font-semibold text-sm sm:text-base leading-snug line-clamp-2 group-hover:text-primary transition">{item.judul}</h3>
                </Link>

                <p className="text-xs text-gray-500">
                  {new Date(item.created_at).toLocaleDateString("id-ID", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </p>
              </div>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default RekomendasiSlider;
